export default __webpack_public_path__ + "static/media/mixkit-arcade-bonus-229.53227744.wav";